<template>
    <div class="flex flex-col">
        <h3 class="text-lg mb-2">{{ title }}</h3>
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <div class="table min-w-full divide-y divide-gray-200">
                        <div class="table-header-group">
                            <div class="table-row bg-gray-50">
                                <div v-for="header in headers" class="table-cell px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    {{ header }}
                                </div>
                            </div>
                        </div>
                        <div class="table-row-group bg-white divide-y divide-gray-200">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {

    name: "Table",

    props: ['data'],

    computed: {
        title(){
            return this.data.title;
        },

        headers(){
            return this.data.headers;
        }
    }

}

</script>
